import React, { useState } from 'react';
import './styles/global.css';

// Import components
import Navbar from './components/Layout/Navbar';
import Footer from './components/Layout/Footer';

// Import pages - make sure these match EXACTLY with file names in pages folder
import Home from './pages/Home';
import About from './pages/About';
import Products from './pages/Products';
import FAQsPage from './pages/FAQS';
import Contact from './pages/Contact';

function App() {
  const [page, setPage] = useState('home');
  
  const go = (p) => { 
    setPage(p); 
    window.scrollTo({ top: 0, behavior: 'smooth' }); 
  };
  
  return (
    <>
      <Navbar page={page} go={go}/>
      {page === 'home' && <Home go={go}/>}
      {page === 'about' && <About go={go}/>}
      {page === 'products' && <Products go={go}/>}
      {page === 'faqs' && <FAQsPage go={go}/>}
      {page === 'contact' && <Contact/>}
      <Footer go={go}/>
    </>
  );
}

export default App;